import React, {useContext} from "react";

import {CartContext} from "@contexts/Cart.jsx"
import {ProductCustomizerCollectionContext} from "@contexts/ProductCustomizerCollection.jsx"
import ProductCustomizerItem from "./ProductCustomizerItem.jsx"

import { getRestIdFromGid } from "@utility/shopify"

export default () => {

  const { cart } = useContext(CartContext);
  const { loading, collection, partnerProduct, compatibilityKeys} = useContext(ProductCustomizerCollectionContext);

  const recomendationNodes = collection?.map((product, index) => {
    
    if(compatibilityKeys && compatibilityKeys.length > 0){
      product.variants = product.variants.filter((variant) => {
        if(variant.compatibilityKeys?.value){
          try{
            const variantCompatibilityKeys = JSON.parse(variant.compatibilityKeys.value);
            const compatible = variantCompatibilityKeys.find((key)=>{
              if(compatibilityKeys.indexOf(key) > -1){
                return true;
              }
            });
            return compatible;
          }catch(e){
            console.error(e);
            return true;
          }
        }else{
          return true;
        }
      });
      //console.log(product);
      if(product.additionalOptions?.references.length > 0){
        product.additionalOptions.references = filterReferencesByCompatibility(product.additionalOptions.references, compatibilityKeys);
      }

    }else{
      product.variants = [...product.variants]
    }

    if(product.variants.length > 0){
      const variantIds = product.variants.map( (variant) => getRestIdFromGid(variant.id) );
      const item = cart?.items.find((item) => {
        return variantIds.indexOf(item.variant_id.toString()) > -1;
      });

      return <ProductCustomizerItem item={item} product={product} key={index} hideSoldOut={true} />
    }else{
      return null;
    }
  })

  if(compatibilityKeys && compatibilityKeys.length > 0 && partnerProduct?.additionalOptions?.references.length > 0){
    partnerProduct.additionalOptions.references = filterReferencesByCompatibility(partnerProduct.additionalOptions.references, compatibilityKeys);
  }

  const partnerItem = cart?.items.find((item) => {
    return partnerProduct?.variants.length && partnerProduct?.variants[0].id.indexOf(item.variant_id.toString()) > -1;
  });
  
  const partnerProductNode = partnerProduct ? <ProductCustomizerItem item={partnerItem} product={partnerProduct} key={"partner"} hideSoldOut={true}  /> : null;

  return <div>
          {loading ?
            "Loading"
          :
            <div className="cart-drawer__line-items">
              <p class="h6">{window.themeVariables?.strings?.cartEssentials || 'Add Essentials'}</p>
              {partnerProductNode}
              {recomendationNodes}
            </div>
          }
      </div>
}


const filterReferencesByCompatibility = (references, compatibilityKeys) => {
  return references.filter((item) => {
    if( item.variant?.reference?.compatibilityKeys?.value ){
      try{
        const variantCompatibilityKeys = JSON.parse(item.variant.reference.compatibilityKeys.value);
        const compatible = variantCompatibilityKeys.find((key)=>{
          if(compatibilityKeys.indexOf(key) > -1){
            return true;
          }
        });
        return compatible;
      }catch(e){
        console.error(e);
        return true;
      }
    }else{
      return true;
    }
  });
}